'use client';

import { IconButton } from '@mui/material';

import { styled } from '../../styles';

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  zIndex: 99,
  top: theme.spacing(0),
  right: theme.spacing(0),
  padding: theme.spacing(1),
  margin: theme.spacing(2),

  svg: {
    width: 24,
    height: 24,
  },
}));
